import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import label from '../../utils/lngEn';
import FormField from '../common/FormField';
import TextAreaField from '../common/TextAreaField';
import Validate from '../common/formValidate';
import CheckboxField from '../form/CheckboxField';

const validate = (values, props) => {
  const errors = {};
  // Don't validate target/max when the assignment is complete
  if (!values.target_capacity && values.target_capacity !== 0) {
    errors.target_capacity = 'Required';
  } else if (values.target_capacity < 0) {
    errors.target_capacity = 'Must be at least zero';
  } else if (!(props.assignment_complete) && values.max_capacity && values.target_capacity > values.max_capacity) {
    errors.target_capacity = 'Capacity must be equal to or lower than actual capacity';
  }
  return errors;
};
const number = value => (value ? +value : null);
const CourseForm = props => {
  const { handleSubmit, submitting, initialValues, assignment_complete = false } = props;
  return (
    <form onSubmit={handleSubmit} className="mt-4">
      {!initialValues.id ? (
        <Field
          name="slug"
          type="text"
          component={FormField}
          label={label.courseForm_ClassName}
          validate={[Validate.Required]}
          description={label.courseForm_ClassNameDesc}
        />
      ) : null}
      <Field
        name="identifier"
        type="text"
        component={FormField}
        label={label.courseForm_ClassIdentifier}
        validate={[]}
        description={label.courseForm_ClassIdentifierDesc}
      />
      <Field
        name="longname"
        type="text"
        component={FormField}
        validate={[Validate.StringRange150]}
        label={label.courseForm_ClassLongname}
        description={label.courseForm_ClassLongnameDesc}
      />
      <Field
        name="description"
        type="text"
        component={TextAreaField}
        label={label.courseForm_ClassDescription}
        description={label.courseForm_ClassDescriptionDesc}
      />
      <Field
        name="external_url"
        type="url"
        component={FormField}
        validate={[]}
        label={label.courseForm_LinkToClass}
        description={label.courseForm_LinkToClassDesc}
      />
      <Field
        name="instructor"
        type="text"
        component={FormField}
        label={label.courseForm_InstructorName}
        validate={[]}
        description={label.courseForm_InstructorNameDesc}
      />
      <Row>
        {assignment_complete
          ? [
              <Col md={4} key="weight">
                <Field
                  name="weight"
                  type="number"
                  component={FormField}
                  label={label.courseForm_Credits}
                  validate={[Validate.PositiveNumber]}
                  description={label.courseForm_CreditsDesc}
                />
              </Col>,
              <Col md={4} key="target_capacity">
                <Field
                  name="target_capacity"
                  type="number"
                  min="0"
                  props={{assignment_complete: assignment_complete}}
                  component={FormField}
                  normalize={number}
                  label={label.courseForm_DisplayedCapacity}
                  description={label.courseForm_DisplayedCapacityDesc}
                />
              </Col>,
              <Col md={12} key="allow_pass_fail">
                <div className="rawSelect">
                  <Field
                    name="allow_pass_fail"
                    type="checkbox"
                    normalize={value => !!value}
                    component={CheckboxField}
                    description="Allow Students to Take This Class Pass/Fail"
                  />
                </div>
              </Col>
            ]
          : [
              <Col md={12} key="weight">
                <Field
                  name="weight"
                  type="number"
                  component={FormField}
                  label={label.courseForm_Credits}
                  validate={[Validate.PositiveNumber]}
                  description={label.courseForm_CreditsDesc}
                />
              </Col>,
              <Col md={6} key="target_capacity">
                <Field
                  name="target_capacity"
                  key="target_capacity"
                  type="number"
                  min="0"
                  component={FormField}
                  normalize={number}
                  props={{assignment_complete: assignment_complete}}
                  label={label.courseForm_DisplayedCapacity}
                  description={label.courseForm_DisplayedCapacityDesc}
                />
              </Col>,
              <Col md={6}>
                <Field
                  name="max_capacity"
                  key="max_capacity"
                  type="number"
                  min="0"
                  component={FormField}
                  normalize={number}
                  label={label.courseForm_MaxCapacity}
                  description={label.courseForm_MaxCapacityDesc}
                />
              </Col>
            ]}
      </Row>
      <button className="btn btn-primary pull-right" type="submit" disabled={submitting}>
        Save
      </button>
    </form>
  );
};

export default reduxForm({
  form: 'CourseForm',
  validate
})(CourseForm);



// WEBPACK FOOTER //
// ./src/components/classes/ClassForm.js